module.exports = __webpack_public_path__ + "static/together_bg1_m-77b043f42138357c3cb578ecbb074510.jpg";